module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_10.ecf8f357.png";